import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 7V6.68C21.0078 6.54903 20.9648 6.4201 20.88 6.32L20.71 6.15C20.6635 6.10314 20.6082 6.06594 20.5473 6.04055C20.4864 6.01517 20.421 6.0021 20.355 6.0021C20.289 6.0021 20.2236 6.01517 20.1627 6.04055C20.1018 6.06594 20.0465 6.10314 20 6.15L18.41 7.71C18.3153 7.79931 18.1901 7.84906 18.06 7.84906C17.9299 7.84906 17.8047 7.79931 17.71 7.71L16.29 6.29C16.1984 6.19654 16.1471 6.07088 16.1471 5.94C16.1471 5.80912 16.1984 5.68346 16.29 5.59L17.85 4.03C17.8969 3.98352 17.9341 3.92822 17.9594 3.86729C17.9848 3.80636 17.9979 3.74101 17.9979 3.675C17.9979 3.60899 17.9848 3.54364 17.9594 3.48271C17.9341 3.42178 17.8969 3.36648 17.85 3.32L17.68 3.15C17.5846 3.05428 17.4551 3.00033 17.32 3H17C15.9391 3 14.9217 3.42143 14.1716 4.17157C13.4214 4.92172 13 5.93913 13 7C12.9885 7.5344 13.0872 8.06545 13.29 8.56L3.29 18.56C3.10526 18.7463 3.0011 18.9977 3 19.26V19.44C3.0011 19.7023 3.10526 19.9537 3.29 20.14L3.83 20.68C4.01626 20.8647 4.26766 20.9689 4.53 20.97H4.74C5.00234 20.9689 5.25374 20.8647 5.44 20.68L15.44 10.68C15.9324 10.8931 16.4635 11.0021 17 11C18.0609 11 19.0783 10.5786 19.8284 9.82843C20.5786 9.07828 21 8.06087 21 7Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgAdminTools = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgAdminTools;
